<template>
  <div>
    <v-row>
      <v-col cols="12">
        <p class="text-2xl">
          Análise de Templates
        </p>
        <v-card
          flat
        >
          <v-card-text class="pa-3">
            <v-row>
              <v-col
                cols="12"
                md="2"
                sm="6"
              >
                <v-text-field
                  v-model="filterTemplateId"
                  :append-icon="icons.mdiMagnify"
                  clearable
                  hide-details
                  dense
                  label="ID Template"
                  outlined
                  @click:append="fechSmsTemplates"
                  @keypress.enter="fechSmsTemplates"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
                sm="6"
              >
                <v-autocomplete
                  v-model="filterUserId"
                  :items="users"
                  clearable
                  label="Usuário"
                  outlined
                  hide-details
                  dense
                  item-text="value"
                  item-value="id"
                  placeholder="Todos"
                  @change="fechSmsTemplates"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
                sm="6"
              >
                <v-autocomplete
                  v-model="filterStatus"
                  :items="smsTemplateStatus"
                  clearable
                  label="Status"
                  outlined
                  hide-details
                  dense
                  item-text="text"
                  item-value="value"
                  placeholder="Todos"
                  @change="fechSmsTemplates"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
                sm="6"
              >
                <v-autocomplete
                  v-model="filterServiceId"
                  :items="smsServiceTypes"
                  clearable
                  label="Serviço"
                  outlined
                  hide-details
                  dense
                  item-text="text"
                  item-value="serviceId"
                  placeholder="Todos"
                  @change="fechSmsTemplates"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-text-field
                  v-model="filterMessage"
                  :append-icon="icons.mdiMagnify"
                  clearable
                  hide-details
                  dense
                  label="Mensagem"
                  outlined
                  @click:append="fechSmsTemplates"
                  @keypress.enter="fechSmsTemplates"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions class="pa-3">
            <v-btn
              color="primary"
              class="pl-4"
              @click="fechSmsTemplates"
            >
              Pesquisar
              <v-icon
                right
                dark
              >
                {{ icons.mdiMagnify }}
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-card
          flat
          class="mt-5"
        >
          <v-data-table
            :headers="headers"
            :items="rows"
            item-key="id"
            class="table-rounded"
            disable-sort
            dense
          >
            <template #[`item.action`]="{item}">
              <v-btn
                color="info"
                dark
                text
                title="Visualizar"
                x-small
                @click="openDialog(item)"
              >
                <v-icon>{{ icons.mdiEye }}</v-icon>
              </v-btn>
            </template>

            <template #[`item.smsTemplate.status`]="{item}">
              <v-chip
                class="my-2"
                :color="resolveStatus(item.smsTemplate.status).color"
                small
                label
              >
                <span class="white--text font-weight-semibold">
                  {{ resolveStatus(item.smsTemplate.status).value }}
                </span>
              </v-chip>
            </template>

            <template #[`item.smsTemplate.observation`]="{item}">
              <span v-if="item.smsTemplate.status === smsTemplate.Refused">
                {{ resolveObservation(item.smsTemplate.observation) }}
              </span>
            </template>

            <template #[`item.smsTemplate.createdAt`]="{item}">
              <span>{{ $day(item.smsTemplate.createdAt).format('DD/MM/YYYY HH:mm:ss') }}</span>
            </template>

            <template #[`item.smsTemplate.serviceIds`]="{item}">
              <v-chip
                v-for="(service, index) in item.smsTemplate.serviceIds"
                :key="index"
                class="ma-1"
                small
              >
                <span class="white--text font-weight-semibold primary--text">
                  {{ resolveServiceName(service) }}
                </span>
              </v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialogTemplate"
      :width="800"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ `SMS Template (#${form.id})` }}
          <v-spacer />
          <v-btn
            text
            x-small
            fab
            @click="dialogTemplate = false"
          >
            <v-icon color="error">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              md="8"
            >
              <v-text-field
                v-model="form.name"
                outlined
                hide-details
                dense
                label="Nome"
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-select
                v-model="form.status"
                :items="smsTemplateStatus"
                :readonly="!isAdmin"
                hide-details
                label="Status"
                item-text="text"
                item-value="value"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <v-select
                v-model="form.serviceIds"
                :items="smsServiceTypes"
                :readonly="!isAdmin"
                hide-details
                chips
                label="Serviços Associados"
                item-text="text"
                item-value="serviceId"
                multiple
                outlined
                dense
              >
                <template v-slot:selection="{ item }">
                  <v-chip
                    color="info"
                    label
                    small
                  >
                    {{ item.text }}
                  </v-chip>
                </template>
              </v-select>
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <v-textarea
                v-model="form.message"
                :readonly="!isAdmin"
                counter="1000"
                outlined
                dense
                label="Mensagem"
                hint="Não utilize emojis. Máximo de 1000 caracteres."
                persistent-hint
                rows="8"
              />
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <v-combobox
                v-model="form.variables"
                :items="form.variables"
                :readonly="!isAdmin"
                chips
                label="Variáveis"
                multiple
                outlined
                dense
                hint="Remova todos os itens para limpar as variáveis. A alteração da mensagem atualiza as variáveis entre chaves {}."
                persistent-hint
              >
                <template v-slot:selection="{ item }">
                  <v-chip
                    color="info"
                    label
                    small
                    close
                    @click:close="removeVariable(item)"
                  >
                    {{ item }}
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider v-if="isAdmin" />
        <v-card-actions v-if="isAdmin">
          <v-spacer />
          <v-btn
            v-if="smsTemplate.Pending === form.status"
            color="error"
            outlined
            @click="dialogTemplateRefuse = true"
          >
            Recusar
          </v-btn>
          <v-btn
            v-if="smsTemplate.Pending === form.status"
            color="success"
            @click="approveTemplate(form.id, form.serviceIds)"
          >
            Aprovar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveAdminTemplate"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <validation-observer
      ref="formRefuseTemplate"
      autocomplete="off"
      tag="form"
    >
      <v-dialog
        v-model="dialogTemplateRefuse"
        :width="400"
        persistent
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Recusar Template
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                md="12"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="Motivo"
                  rules="required|max:300"
                  vid="formRefuse.observation"
                >
                  <v-textarea
                    v-model="formRefuse.observation"
                    :error-messages="errors"
                    :hide-details="errors.length === 0"
                    counter
                    outlined
                    dense
                    label="Motivo"
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error"
              outlined
              @click="dialogTemplateRefuse = false"
            >
              Fechar
            </v-btn>
            <v-btn
              color="error"
              @click="refuseTemplate()"
            >
              Recusar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </validation-observer>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import {
  mdiClose,
  mdiEye,
  mdiMagnify,
} from '@mdi/js'
import { ref } from 'vue'
import { ROLE_TYPE } from '@/store/auth/mutations'
import { smsTemplate, smsTemplateStatus, smsTypes } from '@/utils/enum'

const SMS_SERVICE_IDS = [1, 5, 6, 7, 8, 9, 10]
const EMOJI_REGEX = /\p{Extended_Pictographic}/u

export default {
  setup() {
    const users = ref([])
    const filterTemplateId = ref(null)
    const filterUserId = ref(null)
    const filterStatus = ref(null)
    const filterServiceId = ref(null)
    const filterMessage = ref(null)
    const dialogTemplate = ref(false)
    const dialogTemplateRefuse = ref(false)
    const syncingForm = ref(false)
    const originalForm = ref({
      status: null,
      message: '',
      serviceIds: [],
      variables: [],
    })
    const form = ref({
      id: ref(null),
      name: ref(null),
      serviceIds: ref([]),
      observation: ref(null),
      message: ref(null),
      status: ref(null),
      variables: ref([]),
    })

    const formRefuse = ref({
      id: ref(null),
      observation: ref(null),
    })

    const resolveStatus = status => {
      if (status === smsTemplate.Pending) return { color: 'info', value: 'Aguardando Análise' }
      if (status === smsTemplate.Approved) return { color: 'success', value: 'Aprovado' }

      return { color: 'error', value: 'Recusado' }
    }

    const resolveObservation = value => {
      const index = value.indexOf('motivo: ')

      if (index !== -1) {
        return value.substring(index)
      }

      return ''
    }

    const resolveServiceName = serviceId => {
      const service = smsTypes.find(smsType => smsType.serviceId === serviceId)

      if (service) {
        return service.text
      }

      return null
    }

    return {
      users,
      filterTemplateId,
      filterStatus,
      filterUserId,
      filterServiceId,
      filterMessage,
      dialogTemplate,
      dialogTemplateRefuse,
      syncingForm,
      originalForm,
      form,
      formRefuse,
      resolveStatus,
      resolveObservation,
      resolveServiceName,
      smsTemplate,
      smsTemplateStatus,
      smsServiceTypes: smsTypes.filter(item => SMS_SERVICE_IDS.includes(item.serviceId)),
      icons: {
        mdiClose,
        mdiEye,
        mdiMagnify,
      },
      headers: [
        { text: 'Ações', value: 'action', align: 'center' },
        { text: 'ID', value: 'smsTemplate.id' },
        { text: 'Status', value: 'smsTemplate.status' },
        { text: 'Template', value: 'smsTemplate.name' },
        { text: 'Cód. Usuário', value: 'user.id' },
        { text: 'Usuário', value: 'user.name' },
        { text: 'Data Criação', value: 'smsTemplate.createdAt' },
        { text: 'Serviços Associados', value: 'smsTemplate.serviceIds' },
        { text: 'Observação', value: 'smsTemplate.observation', width: '500px' },
      ],
    }
  },

  computed: {
    ...mapState('reportSmsTemplates', [
      'rows',
    ]),
    isAdmin() {
      const role = Number(Buffer.from(localStorage.getItem('role'), 'base64'))

      return role === ROLE_TYPE.admin
    },
  },

  watch: {
    // eslint-disable-next-line func-names
    'form.message': function (value) {
      if (this.syncingForm) return

      this.form.variables = this.getVariables(value)
    },
  },

  async created() {
    if (!this.isAdmin) {
      this.$router.replace('/')

      return
    }

    await this.findUsers()
    await this.fechSmsTemplates()
  },

  methods: {
    ...mapActions('reportSmsTemplates', [
      'find',
      'approve',
      'refuse',
      'updateAdmin',
    ]),
    ...mapActions('user', {
      fetchUsers: 'find',
    }),

    getVariables(text) {
      const regex = /\{([^}]+)\}/g

      return String(text || '').match(regex)?.map(v => v.slice(1, -1).toUpperCase()) || []
    },

    normalizeVariables(variables) {
      return [...new Set(
        [...(variables || [])]
          .map(variable => String(variable).trim().toUpperCase())
          .filter(Boolean),
      )]
    },

    sameIds(left = [], right = []) {
      const a = [...left].map(Number).sort((x, y) => x - y)
      const b = [...right].map(Number).sort((x, y) => x - y)

      return a.length === b.length && a.every((value, index) => value === b[index])
    },

    sameVariables(left = [], right = []) {
      const a = this.normalizeVariables(left)
      const b = this.normalizeVariables(right)

      return a.length === b.length && a.every((value, index) => value === b[index])
    },

    hasEmoji(text) {
      return EMOJI_REGEX.test(String(text || ''))
    },

    removeVariable(item) {
      this.form.variables = this.normalizeVariables(this.form.variables)
        .filter(variable => variable !== item)
    },

    openDialog(row) {
      this.syncingForm = true
      this.dialogTemplate = true
      this.dialogTemplateRefuse = false
      this.form = {
        id: row.smsTemplate.id,
        message: row.smsTemplate.message,
        name: row.smsTemplate.name,
        status: row.smsTemplate.status,
        serviceIds: [...(row.smsTemplate.serviceIds || [])],
        variables: this.normalizeVariables(row.smsTemplate.variables),
      }
      this.originalForm = {
        status: row.smsTemplate.status,
        message: row.smsTemplate.message || '',
        serviceIds: [...(row.smsTemplate.serviceIds || [])],
        variables: this.normalizeVariables(row.smsTemplate.variables),
      }
      this.formRefuse = {
        id: row.smsTemplate.id,
        observation: '',
      }
      this.$nextTick(() => {
        this.syncingForm = false
      })
    },

    async findUsers() {
      const users = await this.fetchUsers()

      this.users = users.map(user => ({
        ...user,
        value: `${user.document ? String(this.$cpfCnpj.toMask(user.document)).concat(' - ', user.name) : user.name}`,
      }))
    },

    async fechSmsTemplates() {
      const filter = {}
      const templateId = Number(this.filterTemplateId)
      const message = String(this.filterMessage || '').trim()

      if (this.filterTemplateId !== null && this.filterTemplateId !== '' && !Number.isNaN(templateId)) {
        filter.templateId = templateId
      }

      if (this.filterUserId) {
        filter.userId = this.filterUserId
      }

      if (this.filterStatus) {
        filter.status = this.filterStatus
      }

      if (message) {
        filter.message = message
      }

      if (this.filterServiceId) {
        filter.serviceId = this.filterServiceId
      }

      await this.find(filter)
    },

    async approveTemplate(id, serviceIds) {
      if (serviceIds.length === 0) {
        this.$notify('Selecione ao menos um serviço.', 'error')

        return
      }

      const status = await this.approve({ id, serviceIds })

      if (status) {
        this.dialogTemplate = false
        this.fechSmsTemplates()
      }
    },

    async refuseTemplate() {
      const body = {
        id: this.formRefuse.id,
        observation: this.formRefuse.observation,
      }

      if (await this.$refs.formRefuseTemplate.validate()) {
        const status = await this.refuse(body)

        if (status) {
          this.dialogTemplateRefuse = false
          this.dialogTemplate = false
          this.fechSmsTemplates()
        }
      }
    },

    async saveAdminTemplate() {
      const { status } = this.form
      const message = this.form.message || ''
      const serviceIds = this.form.serviceIds || []

      if (this.hasEmoji(message)) {
        this.$notify('A mensagem não pode conter emojis.', 'error')

        return
      }

      if (message.length > 1000) {
        this.$notify('O campo mensagem pode conter até 1000 caracteres.', 'error')

        return
      }

      if (status === smsTemplate.Approved && serviceIds.length === 0) {
        this.$notify('Selecione ao menos um serviço.', 'error')

        return
      }

      const body = {}

      if (status !== this.originalForm.status) {
        body.status = status
      }

      if (message !== this.originalForm.message) {
        body.message = message
      }

      if (!this.sameIds(serviceIds, this.originalForm.serviceIds)) {
        body.serviceIds = serviceIds
      }

      const variables = this.normalizeVariables(this.form.variables)

      if (!this.sameVariables(variables, this.originalForm.variables)) {
        body.variables = variables
      }

      if (Object.keys(body).length === 0) {
        this.$notify('Nenhuma alteração para salvar.', 'warning')

        return
      }

      const updated = await this.updateAdmin({
        id: this.form.id,
        body,
      })

      if (updated) {
        this.dialogTemplate = false
        this.fechSmsTemplates()
      }
    },
  },
}
</script>
